import { Box, SvgIcon, SvgIconProps } from "@mui/material";
import * as React from "react";

export interface IconProps extends SvgIconProps {}

const ExpendViewIcon = (props: IconProps) => {
  return (
    <SvgIcon {...props}><path d="M0 24V13.333h2.667v6.134l16.8-16.8h-6.134V0H24v10.667h-2.667V4.533l-16.8 16.8h6.134V24H0Z"/></SvgIcon>
  );
};

export default ExpendViewIcon;